export default "__VITE_ASSET__Da9i2Pbt__"